import { FC } from 'react';
import { Box, Typography } from '@mui/material';

const labelStyles = {
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: '1.375rem',
  color: '#162936',
};

const fieldLabelStyles = {
  fontSize: '0.75rem',
  fontWeight: 500,
  color: '#6C6C6C',
};

const ReadonlyField: FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Typography sx={fieldLabelStyles}>{label}</Typography>
    <Typography sx={labelStyles}>{value}</Typography>
  </Box>
);

type UserInfoSectionProps = {
  userName: string;
  email: string;
};

const UserInfoSection: FC<UserInfoSectionProps> = ({ userName, email }) => (
  <Box sx={{ display: 'flex', gap: '4rem' }}>
    {userName ? <ReadonlyField label="User Name" value={userName} /> : null}
    {email ? <ReadonlyField label="Email Address" value={email} /> : null}
  </Box>
);

export default UserInfoSection;
